export const BASIC_COMBO = 1;
export const FLEX_FOUR = 2;
export const SIMPLY_SIX = 3;
export const READERS_DELIGHT = 4;
export const TYPES = {
    1: "BASIC COMBO",
    2: "FLEX FOUR",
    3: "SIMPLY SIX",
    4: "READERS DELIGHT",
};
